module.exports = __webpack_public_path__ + "assets/ad8b2735b1e1886f0caca19595498c56.png";